/**
 * Gets the file name at the end of a url (i.e. 1.1.0)
 *
 * @param {string} url url
 *
 * @returns {string} the file name
 */
export default (url) => {
  const URL = window.URL || window.webkitURL;
  const urlObj = new URL(url);
  const fileName = urlObj.pathname.split("/").pop();
  return fileName;
};
